import React, { useEffect, useState } from "react";

const EmployeeFilter = (props) => {

  const [selectedRole, setSelectedRole] = useState("All");

  const handleSelectEmployeeRole = (role) => {
    setSelectedRole(role);
    props.employeeFilterRole(role);
  }
    useEffect(() => {
    if (props.isReset) {
      setSelectedRole("All");
      props.employeeFilterRole("All");
      if (props.handleResetState) {
        props.handleResetState();
      }
    }
  }, [props.isReset]);
  // useEffect(()=>{
  //   console.log
  // },[props])

  return(
    <div className="w-full">
      <p className="fs-16 m-t-8 m-b-12 font-weight-700 color-black">Filter by Role</p>
       <div onClick={()=>handleSelectEmployeeRole("All")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "All"} />
        <p className="flex-item fs-16">All</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Gym Admin")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Gym Admin"}/>
        <p className="flex-item fs-16">Gym Admin</p>
      </div>
      <div  onClick={()=>handleSelectEmployeeRole("General Trainer")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "General Trainer"}/>
        <p className="flex-item fs-16">General Trainer</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Sales Consultant")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Sales Consultant"}/>
        <p className="flex-item fs-16">Sales Consultant</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Personal Training")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Personal Training"}/>
        <p className="flex-item fs-16">Personal Training</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Sales Lead")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Sales Lead"}/>
        <p className="flex-item fs-16">Sales Lead</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Personal Trainer Lead")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Personal Trainer Lead"}/>
        <p className="flex-item fs-16">Personal Trainer Lead</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Fitness Lead")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Fitness Lead"}/>
        <p className="flex-item fs-16">Fitness Lead</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Nutritionist")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Nutritionist"}/>
        <p className="flex-item fs-16">Nutritionist</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("GroupX Lead")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "GroupX Lead"}/>
        <p className="flex-item fs-16">GroupX Lead</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Receptionist")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Receptionist"}/>
        <p className="flex-item fs-16">Receptionist</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Security")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Security"}/>
        <p className="flex-item fs-16">Security</p>
      </div>
      <div onClick={()=>handleSelectEmployeeRole("Freelancer")} className="d-flex m-b-6">
        <input className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} checked={selectedRole == "Freelancer"}/>
        <p className="flex-item fs-16">Freelancer</p>
      </div>
    </div>
  )
}

export default EmployeeFilter;